export default "__VITE_ASSET__DKdZBWON__"